import { Grid, Typography, Box, makeStyles, } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import StoryContext from '../../contexts/StoryContext';
import SubquestionBox from '../SubquestionBox';
import AccessBySettingTypeSubsidy from './AccessBySettingTypeSubsidy';
import AccessByQualityRatingSubsidy from './AccessByQualityRatingSubsidy';
import CountyComparisonTableSubsidy from './CountyComparisonTableSubsidy';
import CountyContext from '../../contexts/CountyContext';
import CountyMapSubsidy from './CountyMapSubsidy';
import Filters from './Filters';
import FiltersContext from '../../contexts/FiltersContext';
import ErrorBoundary from '../ErrorBoundary';

function Q2Row3() {
  const [familyType, setFamilyType] = useState('All');
  const [settingType, setSettingType] = useState('All');
  const [childAge, setChildAge] = useState('All');

  const [county, setCounty] = useState(null);
  const [countyCode, setCountyCode] = useState(null);

  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    },
  }))();

  return (
    <FiltersContext.Provider value={{
      familyType, setFamilyType, settingType, setSettingType, childAge, setChildAge,
    }}
    >
      <CountyContext.Provider value={{
        county, setCounty, countyCode, setCountyCode,
      }}
      >
        <SubquestionBox color={lightColor}>
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >

            <Grid item xs={12}>
              <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
                Access to subsidized child care by county
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Box displayPrint="none">
                <Filters />
              </Box>
            </Grid>
            <Grid item xs={12} sm={8}>
              <Box displayPrint="none">
                <Typography variant="h6" align="center" style={{ textTransform: 'none' }} gutterBottom>
                  To explore access to providers accepting subsidies by county, click on one below.
                </Typography>
              </Box>
              <ErrorBoundary>
                <CountyMapSubsidy />
              </ErrorBoundary>
            </Grid>
            <Grid item xs={12} sm={4}>
              <Grid container spacing={2}>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <AccessBySettingTypeSubsidy height={245} />
                  </ErrorBoundary>
                </Grid>
                <Grid item xs={12} align="center">
                  <ErrorBoundary>
                    <AccessByQualityRatingSubsidy height={245} />
                  </ErrorBoundary>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <div className="pagebreak100" />
          <Grid
            spacing={2}
            container
            direction="row"
            justify="center"
            alignItems="flex-start"
          >
            <Grid item xs={12}>
              <ErrorBoundary>
                <CountyComparisonTableSubsidy />
              </ErrorBoundary>
            </Grid>
          </Grid>

        </SubquestionBox>
      </CountyContext.Provider>
    </FiltersContext.Provider>
  );
}

export default Q2Row3;
